export const AsyncStatus = {
  Idle: 'idle',
  Loading: 'loading',
  Ready: 'ready',
  Error: 'error',
} as const;
export type AsyncStatus = (typeof AsyncStatus)[keyof typeof AsyncStatus];

export type AsyncState<T, E = string> =
  | { status: typeof AsyncStatus.Idle }
  | { status: typeof AsyncStatus.Loading }
  | { status: typeof AsyncStatus.Ready; data: T }
  | { status: typeof AsyncStatus.Error; error: E };
